import { InteractionButtonProps } from "./types";
import TooltipWithMount from "@/components/atoms/tooltipWithMount/TooltipWithMount";
import { Button } from "@fluentui/react-components";
import { useStyle } from "./style";

export const InteractionButton = (props: InteractionButtonProps) => {
	const classes = useStyle();

	return (
		<TooltipWithMount
			key={"below"}
			withArrow
			positioning={"below"}
			content={{
				children: props.tooltipMessage ?? "",
				className: classes.tooltipContent,
			}}
			relationship="label"
		>
			<div
				onClick={() => {
					return props.onClickCallBack();
				}}
			>
				<Button
					className={props.color === "white" ? classes.white : classes.green}
					icon={props.icon}
					disabled={props.disabled}
				/>
			</div>
		</TooltipWithMount>
	);
};
